import { Chip } from "@mui/material";

const statusColors = {
  pending: "warning",
  approved: "info",
  paid: "success",
  rejected: "error",
  cancelled: "default",
};

const StatusBadge = ({ status }) => {
  const color = statusColors[status?.toLowerCase()] || "default";

  return (
    <Chip
      label={status}
      color={color}
      size="small"
      sx={{ textTransform: "capitalize" }}
    />
  );
};

export default StatusBadge;
